import { render, staticRenderFns } from "./HotelInquiry.vue?vue&type=template&id=519d5986&scoped=true"
import script from "./HotelInquiry.vue?vue&type=script&lang=js"
export * from "./HotelInquiry.vue?vue&type=script&lang=js"
import style0 from "./HotelInquiry.vue?vue&type=style&index=0&id=519d5986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d5986",
  null
  
)

export default component.exports